import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import LearningPathComponent from '../components/learning-path.component';
import { selectLMSLearningPathsQueryItems } from '../../../../../../redux/lms/learning-path/selector';
import { lmsLearningPaths } from '../../../../../../redux/lms/learning-path/action';
import { selectLMSTopicsListItems } from '../../../../../../redux/lms/topics/selector';
import { lmsTopics } from '../../../../../../redux/lms/topics/action';
import { selectLMScoursesListItems } from '../../../../../../redux/lms/courses/selector';
import { selectListItems } from '../../../../../../redux/library/selector';
import { lmsCourses } from '../../../../../../redux/lms/courses/action';

const ManagementLMSLearningPath = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params: any = useParams();
  const lmsLearningPathsQuery = useSelector(selectLMSLearningPathsQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const topicsListItems = useSelector(selectLMSTopicsListItems)
  const lmsCoursesItemsData = useSelector(selectLMScoursesListItems)
  const libraryData = useSelector(selectListItems)
  const [selectLMSLearningPaths, setSelectLMSLearningPaths] = useState<any>({

  });
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])

  const fetchLMSLearningPathsQueryById = () => {
    dispatch(lmsLearningPaths.query({
      url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/learning-paths/fetch-detail`,
      entity: 'lmsLearningPaths',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: params?.id,
          },
        ],
      },
    })).then(() => {
      setIsQuery(true);
    });
  };

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectLMSLearningPaths({ ...selectLMSLearningPaths, [field]: event });
  };

  // media handle form change
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }


  useEffect(
    () => {
      dispatch(lmsCourses.list({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/courses/fetch`,
        jsonData: {
        }
      }))

        .then(() => {
          if (params?.id > 0) {
            fetchLMSLearningPathsQueryById()

          } else {
            setIsLoading(false)
          }
        })
    },
    []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectLMSLearningPaths(lmsLearningPathsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )
    const eventData = {
      "Id": selectLMSLearningPaths?.LearningPathId || 0,
      "Title": selectLMSLearningPaths?.Title || '',
      "Description": selectLMSLearningPaths?.Description || '',
      "Category": selectLMSLearningPaths?.Category || '',
      "Level": selectLMSLearningPaths?.Level || '',
      "DisplayOrder": selectLMSLearningPaths?.DisplayOrder || 0,
      "IsPublished": selectLMSLearningPaths?.IsPublished || '',
      "Duration": selectLMSLearningPaths?.Duration || '',
      "MappedCourses": {
        "MappedCourseIds": [].concat(selectLMSLearningPaths?.MappedCourseIds || 0)
      },
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []
      }
    };


    if (params?.id > 0) {
      await dispatch(lmsLearningPaths.resetAction({ actionType: 'update' }))
      await dispatch(lmsLearningPaths.update({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/learning-paths`,
        entity: 'lmsLearningPaths',
        jsonData: {
          Context: {},
          Records: [eventData],
        },
      })).then(() => {
        back();
      });
    } else {
      await dispatch(lmsLearningPaths.resetAction({ actionType: 'create' }))
      await dispatch(lmsLearningPaths.create({
        url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/learning-paths`,
        entity: 'lmsLearningPaths',
        jsonData: {
          Context: {},
          Records: [eventData],
        },
      })).then(() => {
        back();
      });
    }
  };

  const back = () => {
    navigate('/management/e-applications/lms/learning-paths');
  };

  return (
    <>
      {lmsLearningPathsQuery?.isLoading ? (
        <PageLoader />
      ) : (
        <LearningPathComponent
          handleInnerFormChange={handleInnerFormChange}
          selectLMSLearningPaths={selectLMSLearningPaths}
          back={back}
          handleFormSubmit={handleFormSubmit}
          onFormItemChange={handleFormMediaItemChange}
          id={params?.id}
          TopicsList={topicsListItems?.result?.items}
          LmsCoursesList={lmsCoursesItemsData?.result?.items}
          learningPathCategory={libraryData?.result?.LearningPathCategory}
          difficultyLevel={libraryData?.result?.DifficultyLevel}
        />
      )}
    </>
  );
};

export default ManagementLMSLearningPath;
